import { defineStore } from "pinia";
import _service from "@/service";
export const useConfigStore = defineStore("config", {
  state: () => ({
    countryList:<any>[]
  }),
  getters: {
    getCounrtryList(state) {
      return state.countryList
    }
    
  },
  actions: {
    // 获取国家列表
    async getOriginCountry() {
      try {
        const {data}:any = await _service.getCountryList({})
        this.countryList = data.map((item:any)=> {
          item.label = `${item.chinese}(${item.english})`
          return item
        })
      } catch (error) {
        this.countryList = [];
      }
    },
  },
});
